import moment from 'moment';
export function formatDateString(dateString, pattern = 'YYYY-MM-DD HH:mm:ss', placeholder = '-') {
	if (!dateString) {
		return placeholder;
	}
	return moment(dateString).format(pattern);
}
